module.exports = __webpack_public_path__ + "static/media/green1.4917842a.mp4";